<app-icon-card headline="select_invoice_add_contact">
    <div class="d-flex flex-column w-100">
        <app-contact-form
                [showMail]="!isPC20CSP"
                [showInvite]="!isPC20CSP"
                (formSubmit)="formSubmit($event)"
                submitButtonLabel="select_invoice_contact_create_next_button"
        >
            <ng-content></ng-content>
        </app-contact-form>
    </div>
</app-icon-card>


